"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Alert = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Alert"));
var _Illustration = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Illustration"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _ModalHeader2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalHeader"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _ChevronBackward2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ChevronBackward"));
var _InputField = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputField"));
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _PasswordValidationBox = _interopRequireDefault(require("./PasswordValidationBox"));
var _context = require("../../../../../services/intl/context");
var _jsxRuntime = require("react/jsx-runtime");
var _ModalHeader, _FormattedMessage, _FormattedMessage2, _ChevronBackward, _FormattedMessage3, _FormattedMessage4;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CreateAccount = ({
  email,
  emailSuggestion,
  onEmailBlur,
  onEmailChange,
  onEmailCorrection,
  onContinue,
  password,
  error,
  emailHint,
  emailError,
  passwordError,
  passwordStrength,
  isLoading,
  showPasswordHint,
  onBack,
  onPasswordChange,
  onPasswordBlur
}) => {
  const intl = (0, _reactIntl.useIntl)();
  const {
    language
  } = (0, _context.useIntl)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [_ModalHeader || (_ModalHeader = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalHeader2.default, {
      illustration: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Illustration.default, {
        name: "Login",
        size: "extraSmall"
      }),
      title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.create_account"
      }),
      description: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.create_account.description"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalSection.default, {
      dataTest: "MagicLogin-CreateAccount",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: onContinue,
        name: "loginCreateAccount",
        children: [error != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack.default, {
          spaceAfter: "small",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
            dataTest: "MagicLogin-CreateAccountAlert",
            type: "critical",
            icon: true,
            labelClose: intl.formatMessage({
              id: "orbit.button_close"
            }),
            children: error
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
          label: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.email"
          })),
          placeholder: intl.formatMessage({
            id: "account.email_placeholder"
          }),
          error: emailError && intl.formatMessage(emailError),
          help: emailHint,
          value: email,
          onChange: onEmailChange,
          onBlur: onEmailBlur,
          name: "email",
          inputMode: "email",
          autoComplete: "email",
          dataTest: "MagicLogin-Email",
          spaceAfter: "small"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: "secondary",
          spaceAfter: "small",
          children: emailSuggestion !== "" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "common.did_you_mean",
            values: {
              x: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
                dataTest: "MagicLogin-EmailCorrector",
                onClick: onEmailCorrection,
                children: emailSuggestion
              })
            }
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
          spacing: "small",
          spaceAfter: "large",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
            label: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.password"
            })),
            type: "password",
            name: "passwordNew",
            autoComplete: "new-password",
            value: password,
            error: passwordError && intl.formatMessage(passwordError),
            onChange: onPasswordChange,
            onBlur: onPasswordBlur,
            dataTest: "MagicLogin-Password"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordValidationBox.default, {
            showHint: showPasswordHint,
            passwordStrength: passwordStrength
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
          direction: "row",
          justify: "between",
          spaceAfter: "large",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            type: "secondary",
            iconLeft: _ChevronBackward || (_ChevronBackward = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronBackward2.default, {})),
            onClick: onBack,
            dataTest: "MagicLogin-GetSingleBookingBack",
            children: _FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.back"
            }))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            dataTest: "MagicLogin-Submit",
            submit: true,
            loading: isLoading,
            children: _FormattedMessage4 || (_FormattedMessage4 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.create"
            }))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          size: "small",
          type: "secondary",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.registration_privacy_policy",
            values: {
              a1: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                href: `/${language.id}/pages/content/terms`,
                rel: "noreferrer noopener",
                target: "_blank",
                children: text
              }),
              a2: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                href: `/${language.id}/pages/content/privacy`,
                rel: "noreferrer noopener",
                target: "_blank",
                children: text
              })
            }
          })
        })]
      })
    })]
  });
};
var _default = CreateAccount;
exports.default = _default;